$(function () {
    $('.search-input').keyup(function () {
        var query = $(this).val();
        let slug_section = $(".item-id").val()
        if (query.length >= 3) {
            $.ajax({
                url: '/admin/search/book',
                type: 'POST',
                data: {word: query, 'slug': slug_section},
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    $('.autocomplete-results').empty();
                    if (data.length == 0) {
                        $('.autocomplete-results').append('<li>Sin resultados</li>');
                    }
                    $.each(data, function (i, item) {
                        //style="border-bottom: "1px solid #FF5001"
                        $('.autocomplete-results').append('<li data-slug="' + item.slug + '">' + item.title + ' - ' + item.isbn + '</li>').find('li:last').css('border-bottom', '1px solid #FF5001');
                    });
                }
            });
        } else {
            $('.autocomplete-results').empty();
        }
    });

    $(document).on('click', '.autocomplete-results li', function () {
        let value = $(this).text()
        let slug = $(this).data('slug')
        $('.search-input').val(value)
        $('.item-search-id').val(slug)
        $('.autocomplete-results').empty()
    });


})
